export default __webpack_public_path__ + "static/clothing-v2-06-top-sleeve-ed2538afc8607f56c4b4047d9d1a4efd.png";